import moment from 'moment';

export const request_guarantee = () => {

    let branch_office_id = localStorage.getItem('selected_branchoffice')
    let branch_offices_warehouses = JSON.parse(localStorage.getItem('branchoffices_warehouses'));

    let branch_office_warehouse = null

    if (branch_offices_warehouses) {
        branch_office_warehouse = branch_offices_warehouses
            .find(bw => +bw.branchoffice_id === +branch_office_id && bw.warehouse_code === '09')
    }

    return {
        id: null,
        branch_office_id: branch_office_id,
        branch_office_warehouse_id: branch_office_warehouse ? branch_office_warehouse.id : localStorage.getItem('selected_branchoffice_warehouse'),
        branch_office_exit_id: branch_office_id,
        branch_office_warehouse_exit_id: localStorage.getItem('selected_branchoffice_warehouse'),
        voucher_type_id: null,
        consecutive: null,
        contact_id: null,
        contact_warehouse_id: null,
        type_id: null,
        reason_id: null,
        invoice_id: null,
        return_id: null,
        option_id: null,
        model_id: null,
        approval_status_id: null,
        request_guarantee_attachments: [],
        request_guarantee_states: [],
        request_guarantee_state: {},
        observation: '',
        images_product: [],
        images_product_loaded: [],
        other_images: [],
        other_images_loaded: [],
        images_guide: [],
        images_guide_loaded: [],
        attachments_deleted: [],
        invoice: {},
        return: {}
    };
};

export default {
    branch_offices: [],
    branch_offices_warehouses: [],
    requests_guarantees: {
        data: []
    },
    documents: [],
    request_guarantee: request_guarantee(),
    action: 'Crear',
    step: 1,
    step_available: 1,
    sending: false,
    modal: {
        show: false
    },
    modal_pdf: {
        pdf: '',
        show: false
    },
    model: {},
    document: {},
    editing: false,
    preloader: false,
    filters: {
        page: 1,
        per_page: 10,
        paginate: true,
        contact_warehouse_id: null,
        dates: [
            moment().add('month', -2).add('days', 1).format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
        ]
    },
    request_types: [],
    devolution_reasons: [],
    guarantee_reasons: [],
    approval_states: [],
    approval_reasons: [],
    documents_by_thread: [],
    options: [],
    models: [],
    steps: [
        {
            step: 1,
            code: 'PGS2',
            text: 'Solicitar',
            icon: 'fa-bell',
            view_codes: ['RTGM01', 'RTGM02']
        },
        {
            step: 2,
            code: 'PGS3',
            text: 'Recibido en bodega',
            icon: 'fa-archive',
            view_codes: ['RTGM01', 'RTGM02']
        },
        {
            step: 3,
            code: 'PGS4',
            text: 'Evaluación',
            icon: 'fa-check-circle-o',
            view_codes: ['RTGM02']
        },
        {
            step: 4,
            code: 'PGS5',
            text: 'Nota crédito',
            icon: 'fa-file-text',
            view_codes: ['RTGM01']
        },
        {
            step: 5,
            code: 'PGS6',
            text: 'NC / Reponer',
            icon: 'fa-file-text',
            view_codes: ['RTGM02']
        }
    ]
};



// WEBPACK FOOTER //
// ./src/b2b/modules/guarantees/state.js